/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_User_CreatedInputs */



/**
* | output |
* | --- |
* | "New user created" |
*
* @param {Team_Manager_User_CreatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_user_created = /** @type {((inputs?: Team_Manager_User_CreatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_User_CreatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvel utilisateur créé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Benutzer erstellt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo utente creato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создан новый пользователь.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo usuario creado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建新用户")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいユーザーが作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया उपयोगकर्ता बनाया गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo usuário criado")
	return /** @type {LocalizedString} */ ("New user created")
});